import { Injectable } from '@angular/core';
import { DefaultUrlSerializer, UrlTree } from '@angular/router';

/*
Angular 2 auto serializes all url parameters that go onto an a tag.
This is generally fine - if the urls are staying within angular 2's router.
Since the majority of these links are going back to the python server,
google app engine was 404ing because it didn't know what '<url>/%3Fagid%3DAG-1234 was.

This will return those characters back to their non-serialized form.
 */
@Injectable()
export class ForAppEngineUrlSerializer extends DefaultUrlSerializer {
  serialize(tree: UrlTree): string {
    const path = super.serialize(tree);
    return path.replace('%3F', '?').replace('%3D', '=').replace('%26', '&');
  }
}
